import { render, staticRenderFns } from "./LandMap.vue?vue&type=template&id=6488a978&scoped=true"
import script from "./LandMap.vue?vue&type=script&lang=js"
export * from "./LandMap.vue?vue&type=script&lang=js"
import style0 from "./LandMap.vue?vue&type=style&index=0&id=6488a978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6488a978",
  null
  
)

export default component.exports